
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { LevelAppsSidebar } from "./LevelAppsSidebar";
import { LevelAppsCategoriesContent } from "./LevelAppsCategoriesContent";
import { LevelAppsWhitelistContent } from "./LevelAppsWhitelistContent";
import { LevelAppsBlacklistContent } from "./LevelAppsBlacklistContent";
import { LevelAppsAllAppsContent } from "./LevelAppsAllAppsContent";

interface LevelAppsTabProps {
  levelId: string;
  appFilter?: any;
  allowedApps?: string[];
  blockedApps?: string[];
}

export const LevelAppsTab = ({ levelId, appFilter, allowedApps, blockedApps }: LevelAppsTabProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState("categories");

  // Restore active section from URL params
  useEffect(() => {
    const section = searchParams.get('appsSection');
    if (section && ['categories', 'whitelist', 'blacklist', 'all-apps'].includes(section)) {
      setActiveSection(section);
    }
  }, [searchParams]);

  // Save active section to URL params
  const handleSectionChange = (section: string) => {
    setActiveSection(section);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('appsSection', section);
    setSearchParams(newSearchParams);
  };

  const renderContent = () => {
    switch (activeSection) {
      case "categories":
        return <LevelAppsCategoriesContent levelId={levelId} appFilter={appFilter} />;
      case "whitelist":
        return <LevelAppsWhitelistContent levelId={levelId} allowedApps={allowedApps} />;
      case "blacklist":
        return <LevelAppsBlacklistContent levelId={levelId} blockedApps={blockedApps} allowedApps={allowedApps} />;
      case "all-apps":
        return <LevelAppsAllAppsContent levelId={levelId} appFilter={appFilter} allowedApps={allowedApps} blockedApps={blockedApps} />;
      default:
        return <LevelAppsCategoriesContent levelId={levelId} appFilter={appFilter} />;
    }
  };

  return (
    <div className="flex h-full">
      <LevelAppsSidebar
        activeSection={activeSection}
        onSectionChange={handleSectionChange}
      />
      <div className="flex-1 overflow-auto">
        <div className="p-6">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};
